/* bys-famiglia-colori — 22/10/2026 (come Pandora): nella GRIGLIA il tocco su un pallino trasforma la scheda in quel colore:
   foto, titolo, prezzo, link e «Aggiungi al carrello» (aggiunge proprio quel colore; se e' esaurito il bottone lo dice).
   Nella pagina prodotto i pallini/miniature restano link normali al prodotto di quel colore. */
(function(){
  function maniglia(u){ var m = String(u || '').match(/\/products\/([^\/?#]+)/); return m ? m[1] : ''; }
  document.addEventListener('click', function(e){
    var s = e.target.closest && e.target.closest('.bysfc--s .bysfc__s'); if (!s) return;
    var c = s.closest('.card-product'); if (!c) return;          // fuori da una scheda: link normale
    e.preventDefault(); e.stopPropagation();
    if (s.classList.contains('is-on')) return;
    var box = s.closest('.bysfc--s'), on = box.querySelector('.bysfc__s.is-on');
    var vecchia = c.getAttribute('data-bys-h') || maniglia(on && on.getAttribute('href')), nuova = maniglia(s.getAttribute('href'));
    // foto (anche quella che il tema mostra al passaggio: tutte le foto dentro il link della scheda)
    if (s.dataset.img) {
      c.querySelectorAll('a img').forEach(function(im){
        if (im.closest('.bysfc')) return;
        im.removeAttribute('srcset'); im.removeAttribute('data-srcset'); im.setAttribute('src', s.dataset.img);
      });
    }
    // link della scheda
    if (vecchia && nuova) c.querySelectorAll('a[href*="/products/' + vecchia + '"]').forEach(function(a){
      if (a.closest('.bysfc')) return; a.setAttribute('href', a.getAttribute('href').replace('/products/' + vecchia, '/products/' + nuova));
    });
    c.setAttribute('data-bys-h', nuova);
    // titolo
    if (s.dataset.titolo) c.querySelectorAll('.x-card-title').forEach(function(t){
      var nm = t.querySelector('.bys-nome'), ds = t.querySelector('.bys-desc'), i = s.dataset.titolo.indexOf(' - ');
      if (nm && ds && i > 0) { nm.textContent = s.dataset.titolo.slice(0, i); ds.textContent = s.dataset.titolo.slice(i + 3); }   // nome in grassetto + descrizione
      else t.textContent = s.dataset.titolo;
    });
    // prezzo: il primo importo della scheda
    if (s.dataset.prezzo) {
      var pr = c.querySelector('.x-card-price');
      if (pr) { var foglie = Array.prototype.filter.call(pr.querySelectorAll('*'), function(x){ return !x.children.length && /\d/.test(x.textContent) && /€|EUR|\$/.test(x.textContent); });
        if (foglie[0]) foglie[0].textContent = s.dataset.prezzo; }
    }
    // carrello: variante del colore scelto
    var disp = s.dataset.disponibile === 'true', esaur = box.getAttribute('data-esaurito') || 'Esaurito';
    c.querySelectorAll('form input[name="id"]').forEach(function(i){ if (s.dataset.variante) i.value = s.dataset.variante; });
    c.querySelectorAll('form button[name="add"]').forEach(function(b){
      if (b.dataset.bysOrig === undefined) { b.dataset.bysOrig = b.innerHTML; b.dataset.bysDis = b.disabled ? '1' : '0'; }
      if (disp) { b.innerHTML = b.dataset.bysOrig; b.disabled = b.dataset.bysDis === '1'; }
      else { b.innerHTML = '<span class="flex items-center justify-center">' + esaur + '</span>'; b.disabled = true; }
    });
    // pallini
    box.querySelectorAll('.bysfc__s').forEach(function(x){ x.classList.toggle('is-on', x === s); x.setAttribute('aria-pressed', x === s ? 'true' : 'false'); });
  }, true);
})();

/* 22/10/2026 filtro «Colore» sopra la griglia: in prova si vede solo con ?anteprima_colore=1 (resta acceso su questo dispositivo);
   un tocco porta alla collezione filtrata per quel colore, mantenendo gli altri filtri e l'ordinamento della pagina. */
(function(){
  try { if (/[?&]anteprima_colore=1/.test(location.search)) localStorage.setItem('bysAnteprimaColore', '1');
        if (/[?&]anteprima_colore=0/.test(location.search)) localStorage.removeItem('bysAnteprimaColore'); } catch (e) {}
  function mostra(){ var on = false; try { on = localStorage.getItem('bysAnteprimaColore') === '1'; } catch (e) {}
    if (on) document.querySelectorAll('[data-bysfcol-box][hidden]').forEach(function(b){ b.removeAttribute('hidden'); }); }
  document.addEventListener('DOMContentLoaded', mostra); mostra();
  new MutationObserver(mostra).observe(document.documentElement, {childList: true, subtree: true});   // i filtri del tema ricaricano la griglia
  document.addEventListener('click', function(e){
    var a = e.target.closest && e.target.closest('a[data-bysfcol]'); if (!a) return;
    var q = location.search.replace(/[?&]anteprima_colore=\d/, '').replace(/[?&]page=\d+/, '').replace(/^&/, '?');
    if (q && q !== '?') { e.preventDefault(); location.href = a.getAttribute('href') + (q.charAt(0) === '?' ? q : '?' + q); }
  }, true);
})();

/* bysfp-compatto — 22/10/2026: filtro Colore compatto. Nome del colore sotto i pallini al passaggio; «Tutti i N colori» apre/chiude il pannello */
(function(){
  var RIGHE = 14;   // circa due righe di pallini nel pannello
  function testo(l){ var b = l.parentNode.querySelector('[data-bysfp-tutti] span'); if (b) b.textContent = l.classList.contains('is-aperto') ? 'Meno colori' : 'Tutti i ' + l.children.length + ' colori'; }
  function prepara(){
    document.querySelectorAll('[data-bysfp-l]:not([data-bysfp-ok])').forEach(function(l){
      l.setAttribute('data-bysfp-ok', '1');
      var cap = l.parentNode.querySelector('.bysfp__cap'); if (cap) cap.setAttribute('data-vuoto', l.children.length + ' colori');
      var b = l.parentNode.querySelector('[data-bysfp-tutti]'); if (!b || l.children.length <= RIGHE) return;
      b.hidden = false;
      var on = l.querySelector('.is-on'); if (on && Array.prototype.indexOf.call(l.children, on.closest('li')) >= RIGHE) l.classList.add('is-aperto');
      testo(l);
    });
  }
  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('[data-bysfp-tutti]'); if (!b) return;
    e.preventDefault(); var l = b.closest('.bysfp').querySelector('[data-bysfp-l]'); l.classList.toggle('is-aperto'); testo(l);
  });
  function nome(e, entra){
    var v = e.target.closest && e.target.closest('.bysfp__v'); if (!v) return;
    var cap = v.closest('.bysfp').querySelector('.bysfp__cap'); if (!cap) return;
    cap.textContent = entra ? v.getAttribute('data-nome') + (v.classList.contains('is-on') ? ' · tocca per togliere' : '') : (cap.getAttribute('data-def') || '');
  }
  document.addEventListener('mouseover', function(e){ nome(e, true); });
  document.addEventListener('mouseout', function(e){ nome(e, false); });
  document.addEventListener('focusin', function(e){ nome(e, true); });
  document.addEventListener('focusout', function(e){ nome(e, false); });
  document.addEventListener('DOMContentLoaded', prepara); prepara();
  new MutationObserver(prepara).observe(document.documentElement, {childList: true, subtree: true});   // i filtri del tema ridisegnano il pannello
})();
